import template from './templates/results-dropdown-filter.tmpl.html';

export default function ResultsDropdownFilter(l10nService) {
    'ngInject';

        return {
            restrict: 'E',
            template,
            scope: {
                filterTitle: '@',
                filterData: '=',
                filterModel: '=',
            },
            link: function(scope) {

                 /**
                 * Localised filter title
                 * @type {string}
                 */
                scope.filterName = l10nService.localize(scope.filterTitle);

                /**
                 * Property for sorting
                 * @type {string}
                 */
                scope.orderProperty = 'Value';

                /**
                 * Filter can be opened or collapsed (if model is specified the filter should be opened)
                 * @type {boolean}
                 */
                scope.isFilterOpened = !_.isEmpty(scope.filterModel);

                /**
                 * Change filter an open flag
                 */
                scope.changeOpenState = function() {
                    scope.isFilterOpened = !scope.isFilterOpened;
                };

                scope.isFilterDataExists = function(filter) {
                    return !_.isEmpty(filter);
                };

                /**
                 * Convert filter data to common structure if necessary
                 */
                if (scope.isFilterDataExists(scope.filterData)) {

                    /**
                     * Convert each filter item to structure { Key, Value }
                     * @type {Array}
                     */
                    if (!_.isObject(_.first(scope.filterData))) {
                        scope.filterData = _.map(scope.filterData, function(filterItem) {
                            return {Key: filterItem, Value: filterItem};
                        });
                    } else {
                        scope.filterData = _.map(scope.filterData, function(filterItem) {
                            return {Key: l10nService.localize(filterItem.Key), Value: filterItem.Value};
                        });
                    }
                }
            },
        };
}



// WEBPACK FOOTER //
// ./src/app/directives/resultsDropdownFilter.directive.js